import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import PeriodTypesEnum from "../../../../models/PeriodTypesEnum";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IGetInactiveAccountReportDTO from "../../../../models/DTO/IGetInactiveAccountReportDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOnGetInactiveAccountReportDTO from "../../../../models/DTO/IOnGetInactiveAccountReportDTO";
import { Link } from "react-router-dom";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import * as _ from "lodash-es";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IInactiveAccountReport from "../../../../models/DTO/IInactiveAccountReport";
import OwButton from "../../../shared/OwButton/OwButton";
import ExcelJS from "exceljs/dist/exceljs.min.js";
import moment from "moment-timezone";
import IProcessed_Report from "../../../../models/IProcessed_Report";

type Props = {
    processedReport: IProcessed_Report;
};

export const InactiveAccountReport: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [reportDto, setReportDto] = useState<IOnGetInactiveAccountReportDTO>();
    const [filteredReportDto, setFilteredReportDTO] = useState<IInactiveAccountReport[]>();
    const [salesPeopleOptions, setSalesPeopleOptions] = useState<{ name: string }[]>([]);
    const [selectedRep, setSelectedRep] = useState<string>();

    useEffect(() => {
        onReportData(props.processedReport.report_data);
    }, []);

    const downloadExcel = () => {
        if (filteredReportDto) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet("Inactive Accounts");

            const salesPeopleWs: { salesperson: string; ws: ExcelJS.Worksheet }[] = [];

            ws.columns = [
                { header: "Salesperson", key: "salesperson" },
                { header: "Company", key: "company" },
                { header: "Phone", key: "phone" },
                { header: "Email", key: "email" },
                { header: "Customer Internal Id", key: "customer_internal_id" },
                { header: "Ship To City", key: "ship_to_city" },
                { header: "Ship To State", key: "ship_to_state" },
                { header: "Ship To Postal Code", key: "ship_to_postal_code" },
            ];

            const headerCells = ["A1", "B1", "C1", "D1", "E1", "F1", "G1", "H1"];

            for (const headerCell of headerCells) {
                ws.getCell(headerCell).font = {
                    bold: true,
                };
            }

            for (const row of filteredReportDto) {
                ws.addRow({
                    salesperson: row.sales_rep || row.sales_person || "",
                    company: row.name,
                    phone: row.Ship_To.phone || "",
                    email: row.email,
                    customer_internal_id: row.customer_internal_id,
                    ship_to_city: row.Ship_To.city || "",
                    ship_to_state: row.Ship_To.state || "",
                    ship_to_postal_code: row.Ship_To.postal_code || "",
                });
            }
            //
            // const userRows = Object.keys(this.state.reportData?.userDetailsObj);
            //
            // for (const user of userRows) {
            //     const userDetail = this.state.reportData?.userDetailsObj[user];
            //
            //     const name = userDetail?.name;
            //     const email = userDetail?.email;
            //     // tslint:disable-next-line:variable-name
            //     const commission_total = userDetail?.grandTotal || 0;
            //
            //     ws.addRow({ salesperson: name, email, commission: commission_total });
            //
            //     const salesPersonWs = workbook.addWorksheet(name);
            //
            //     salesPersonWs.columns = [
            //         { header: "Account", key: "account" },
            //         { header: "Order", key: "order" },
            //         { header: "Amount", key: "amount" },
            //     ];
            //
            //     salesPersonWs.getCell("A1").font = {
            //         bold: true,
            //     };
            //
            //     salesPersonWs.getCell("B1").font = {
            //         bold: true,
            //     };
            //
            //     salesPersonWs.getCell("C1").font = {
            //         bold: true,
            //     };
            //
            //     const vendorGuids = Object.keys(userDetail.vendors);
            //
            //     for (const vendorGuid of vendorGuids) {
            //         const vendorDetail = userDetail.vendors[vendorGuid];
            //
            //         const grandTotal = vendorDetail.grandTotal;
            //         const account = vendorDetail.name;
            //
            //         const orders = vendorDetail.orders;
            //
            //         for (const order of orders) {
            //             const orderName = order.name;
            //             const commission = order.commission;
            //             const orderGuid = order.guid;
            //
            //             salesPersonWs.addRow({ account, order: orderName, amount: commission });
            //         }
            //     }
            //
            //     salesPeopleWs.push({ salesperson: name, ws: salesPersonWs });
            // }

            const periodStart = ""; //moment(props.startDate).format("YYYY-MM-DD");
            const periodEnd = ""; //moment(props.endDate).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `${periodStart}-${periodEnd}-inactive-accounts-report.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    const onReportData = (data: IOnGetInactiveAccountReportDTO) => {
        const salesReps: string[] = [];
        const salesPeople: string[] = [];

        for (const account of data.accounts) {
            if (account.sales_rep) {
                salesReps.push(account.sales_rep);
            }

            if (account.sales_person) {
                salesPeople.push(account.sales_person);
            }
        }

        const uniqueSalesReps = _.uniq(salesReps);
        const uniqueSalesPeople = _.uniq(salesPeople);

        if (supplierModel.has_rep_groups) {
            const optionsArr = uniqueSalesReps.map((rep) => {
                return { name: rep };
            });

            setSalesPeopleOptions(optionsArr);
        } else {
            const optionsArr = uniqueSalesPeople.map((rep) => {
                return { name: rep };
            });

            setSalesPeopleOptions(optionsArr);
        }

        setReportDto(data);
        setFilteredReportDTO(data.accounts);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        setSelectedRep(value);
    };

    const filterForRep = () => {
        if (reportDto) {
            if (selectedRep?.length) {
                const filteredData = reportDto.accounts.filter((account) => {
                    if (supplierModel.has_rep_groups) {
                        return account.sales_rep === selectedRep;
                    } else {
                        return account.sales_person === selectedRep;
                    }
                });

                setFilteredReportDTO(filteredData);
            } else {
                setFilteredReportDTO(reportDto?.accounts);
            }
        }
    };

    return (
        <div className={"InactiveAccountReport"}>
            {filteredReportDto ? (
                <div>
                    <div className={"mb-3"}>
                        <OwLabel className={"me-3"} title={"excel"} leftIconClass={"fas fa-download"} fn={downloadExcel} />
                    </div>
                    {salesPeopleOptions.length ? (
                        <div className={"d-flex"}>
                            <OwLabel title={"filter_for"} postText={":"} className={"me-2"} />
                            <div className={"d-flex"}>
                                <OwSelectOption
                                    fn={handleChange}
                                    name={"salesPerson"}
                                    titleProp={"name"}
                                    valueProp={"name"}
                                    options={salesPeopleOptions}
                                    className={"me-2"}
                                />
                                <OwButton title={"filter"} fn={filterForRep} />
                            </div>
                        </div>
                    ) : null}
                    <div>
                        <OwLabel title={"total"} postText={":"} className={"me-2"} />
                        {filteredReportDto.length}
                    </div>
                    {filteredReportDto.map((account, index) => {
                        return (
                            <div key={account.guid} className={"mb-3 d-flex"}>
                                <div className={"me-2"}>{index + 1}</div>
                                <div className={"d-flex flex-column"}>
                                    <Link to={`/account/${account.guid}/detail`}>{account.name}</Link>
                                    {account.customer_internal_id ? (
                                        <div className={"text-small"}>
                                            <OwLabel title={"customer_internal_id"} className={"me-2"} />
                                            {account.customer_internal_id}
                                        </div>
                                    ) : null}
                                    {account.email ? (
                                        <div>
                                            <i className={"fas fa-envelope"} /> <a href={`mailto:${account.email}`}>{account.email}</a>
                                        </div>
                                    ) : null}
                                    {!supplierModel.has_rep_groups && account.sales_person ? (
                                        <div>
                                            <i className={"fas fa-user-tie"} /> {account.sales_person}
                                        </div>
                                    ) : null}
                                    {supplierModel.has_rep_groups && account.sales_rep ? (
                                        <div>
                                            <i className={"fas fa-user-tie"} /> {account.sales_rep}
                                        </div>
                                    ) : null}
                                    <div>
                                        <AddressDisplay
                                            address={account.Ship_To}
                                            showPhone={true}
                                            hideMobile={true}
                                            hideFax={true}
                                            hideEmail={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};
